import React from 'react';
import PanelHeader from '../PanelHeader';
import { useEditor } from '../EditorContext';
import { FONT_LIST } from '../constants';
import { addText, updateTextObject } from '../../canvasEditor';
import { isPlainText } from '../fabricHelpers';

export default function TextPanel() {
  const { fabricRef, selection, refreshLayers } = useEditor();
  const selected = selection && isPlainText(selection) ? selection : null;

  const applyFont = (fontFamily) => {
    const fc = fabricRef.current;
    if (!fc) return;
    if (selected) {
      updateTextObject(selected, { fontFamily });
      fc.renderAll();
      return;
    }
    addText(fc, 'Text', { fontFamily });
    refreshLayers?.();
  };

  const patch = (changes) => {
    if (!selected) return;
    updateTextObject(selected, changes);
    fabricRef.current?.renderAll();
    refreshLayers?.();
  };

  return (
    <div className="pixie-panel">
      <PanelHeader title="Fonts" icon="fa-bold" />
      <ul className="pixie-font-list">
        {FONT_LIST.map((font) => (
          <li key={font}>
            <button
              type="button"
              className="pixie-font-row"
              style={{ fontFamily: font }}
              onClick={() => applyFont(font)}
            >
              {font}
            </button>
          </li>
        ))}
      </ul>

      {selected && (
        <div className="pixie-props">
          <PanelHeader title="Text Properties" icon="fa-sliders" />
          <label className="pixie-field">
            Size
            <input
              type="range"
              min={8}
              max={120}
              value={selected.fontSize || 32}
              onChange={(e) => patch({ fontSize: Number(e.target.value) })}
            />
            <span>{selected.fontSize || 32}px</span>
          </label>
          <label className="pixie-field">
            Align
            <select
              value={selected.textAlign || 'left'}
              onChange={(e) => patch({ textAlign: e.target.value })}
            >
              <option value="left">Left</option>
              <option value="center">Center</option>
              <option value="right">Right</option>
            </select>
          </label>
          <label className="pixie-field">
            Color
            <input
              type="color"
              value={typeof selected.fill === 'string' && selected.fill.startsWith('#') ? selected.fill : '#000000'}
              onChange={(e) => patch({ fill: e.target.value })}
            />
          </label>
          <label className="pixie-field pixie-check">
            <input
              type="checkbox"
              checked={!!selected.senderNameChecked}
              onChange={(e) => patch({ senderNameChecked: e.target.checked })}
            />
            Use Sender Name Instead Text
          </label>
        </div>
      )}
    </div>
  );
}
